import TextInput, {TextInputWithoutContainer} from "../../../../component/TextInput/TextInput";
import TreeSelect from "../../../../component/TreeSelect/TreeSelect";
import {listToTree, toastSuccess} from "../../../../assets/functions";
import ImageInput from "../../../../component/ImageInput/ImageInput";
import uploadPlaceholder from "../../../../assets/upload-file.svg";
import {isSellable, resetSingleProductPrices, uploadInformationPictures} from "../../functions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy, faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import TextEditor from "../../../../component/TextEditor/TextEditor";
import Select, {SelectWithoutContainer} from "../../../../component/Select/Select";
import ColorForm from "../ColorForm/ColorForm";
import SizeForm from "../SizeForm/SizeForm";
import PricingForm from "../PricingForm/PricingForm";
import {useEffect, useState} from "react";
import {getAllBrandsObject} from "../../../brands/functions";
import {getAllProductCategoriesObject} from "../../../ProductCategories/functions";
import {getAllProductTypesObject} from "../../../ProductTypes/functions";
import {getAllSellingTypesObject} from "../../../SellingTypes/functions";
import {getAllCurrenciesObject} from "../../../Currencies/functions";
import Loading from "../../../../component/Loading/Loading";
import {baseImagesUrl} from "../../../../assets/Constants";
import InputFileBase64 from "../../../../component/InputFileBase64/InputFileBase64";

const ProductForm = ({product, onChange}) => {
    const [isLoading, setIsLoading] = useState(true);

    const [tempValues, setTempValues] = useState({
        informationPictures: [],
    });

    const [productForm, setProductForm] = useState(product);
    const changeTempValues = (key, value) => {
        const newTempValues = {...tempValues, [key]: value};
        setTempValues(newTempValues);
    }
    const changeProduct = (key, value) => {
        if (key == "pricingMethod" &&
            (productForm.pricingMethod == "VARIABLE" && value != "VARIBALE") ||
            (productForm.pricingMethod != "CONSTATNT" && value == "CONSTATNT") ||
            (productForm.pricingMethod == "VARIABLE_MODEL" && value == "VARIABLE_USER") ||
            (productForm.pricingMethod == "VARIABLE_USER" && value == "VARIABLE_MODEL")
        ) {
            const newSingleProduct = resetSingleProductPrices(productForm.singleProducts);
            const newProduct = {...productForm, singleProducts: newSingleProduct, [key]: value};
            setProductForm(newProduct);
            onChange(newProduct);
            return;
        } else if (key == "sellingTypeId" && !isSellable(productForm.sellingTypeId) && isSellable(value)) {
            const newSingleProduct = resetSingleProductPrices(productForm.singleProducts);
            const newProduct = {...productForm, [key]: value, singleProducts: newSingleProduct, [key]: value};
            setProductForm(newProduct);
            onChange(newProduct);
            return;
        }
        const newProduct = {...productForm, [key]: value};
        setProductForm(newProduct);
        onChange(newProduct);
    }
    const [allBrandObject, setAllBrandObject] = useState([]);
    const [allProductCategoryObject, setAllProductCategoryObject] = useState([]);
    const [allProductTypeObject, setAllProductTypeObject] = useState([]);
    const [allSellingTypeObject, setAllSellingTypeObject] = useState([]);
    const [allCurrencyObject, setAllCurrencyObject] = useState([]);
    const pricingMethodOptions = [
        {
            label: "قیمت ثابت برای همه کاربران",
            value: "CONSTANT",
        }, {
            label: "قیمت متغیر بر حسب سطح کاربری",
            value: "VARIABLE_USER",
        }, {
            label: "قیمت متغیر بر حسب مدل",
            value: "VARIABLE_MODEL",
        }, {
            label: "قیمت متغیر بر حسب مدل و سطح کاربری",
            value: "VARIABLE",
        },
    ];

    useEffect(() => {
        (async () => {
            setAllBrandObject(await getAllBrandsObject());
            setAllProductCategoryObject(await getAllProductCategoriesObject());
            setAllProductTypeObject(await getAllProductTypesObject());
            setAllSellingTypeObject(await getAllSellingTypesObject());
            setAllCurrencyObject(await getAllCurrenciesObject());

            setIsLoading(false);
        })();
    }, []);

    if (isLoading)
        return <Loading/>

    return (
        <div className={"row"}>
            <div className="col-md-6">
                <TextInput label={"نام محصول (فارسی)"} value={productForm.persianName} onChange={(value) => {
                    changeProduct("persianName", value)
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput label={"مدل محصول (فارسی)"} value={productForm.persianModel} onChange={(value) => {
                    changeProduct("persianModel", value)
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput classname={"ltr"} label={"نام محصول (انگلیسی)"} value={productForm.englishName}
                           onChange={(value) => {
                               changeProduct("englishName", value)
                           }}/>
            </div>
            <div className="col-md-6">
                <TextInput classname={"ltr"} label={"مدل محصول (انگلیسی)"} value={productForm.englishModel}
                           onChange={(value) => {
                               changeProduct("englishModel", value)
                           }}/>
            </div>
            <div className="col-12">
                <TextInput label={"گارانتی"} value={productForm.guarantee}
                           onChange={(value) => {
                               changeProduct("guarantee", value)
                           }}/>
            </div>

            <div className="col-12">
                <TreeSelect mode={"radioSelect"} label={"برند"} data={listToTree(allBrandObject, [productForm.brandId])}
                            onChange={(value) => {
                                const newBrandId = value.length == 1 ? value[0] : "";
                                changeProduct("brandId", newBrandId)
                            }}/>
            </div>
            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <label className="card-title mb-2">تصاویر</label>
                            {
                                productForm.pictures.map((picture, index) => {
                                    return (<div key={index} className="col-md-2">
                                        <img
                                            className={`w-100 productImage ${picture == productForm.primaryPicture ? "border border-2 border-success" : ""}`}
                                            src={picture.includes("product_") ? `${baseImagesUrl}product/${picture}` : picture}
                                            onDoubleClick={() => {
                                                changeProduct("primaryPicture", picture)
                                            }}
                                        />
                                        <button className={"btn btn-danger w-100"} onClick={() => {
                                            const newPictures = productForm.pictures.filter((p) => {
                                                if (picture != p) {
                                                    return p;
                                                }
                                            });
                                            changeProduct("pictures", newPictures);
                                            if (productForm.primaryPicture == picture)
                                                changeProduct("primaryPicture", "");

                                        }}>حذف
                                        </button>
                                    </div>)
                                })
                            }
                            <div className="col-md-2">
                                <ImageInput defaultPic={uploadPlaceholder} onChange={(value) => {
                                    const newPictures = [...productForm.pictures, value];
                                    changeProduct("pictures", newPictures)
                                }}/>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <label className="card-title mb-2">ویدئو</label>
                            {
                                productForm.videos.map((video, index) => {
                                    return (<div key={index} className="col-md-2">
                                            <video className={"w-100"} controls>
                                                <source
                                                    src={video.includes("product") ? `${baseImagesUrl}product/${video}` : video}
                                                    type="video/mp4"/>
                                                <source
                                                    src={video.includes("product") ? `${baseImagesUrl}product/${video}` : video}
                                                    type="video/ogg"/>
                                                Your browser does not support the video tag.
                                            </video>

                                            <button className={"btn btn-danger w-100"} onClick={() => {
                                                const newVideos = productForm.videos.filter((v , i) => {
                                                    if (index != i) {
                                                        return v;
                                                    }
                                                });
                                                changeProduct("videos", newVideos);

                                            }}>حذف
                                            </button>
                                    </div>
                                )
                                })
                                }
                            <div className="col-md-2">
                                <InputFileBase64 onChange={(value) => {
                                    const newVideos = [...productForm.videos, value];
                                    changeProduct("videos", newVideos);
                                }}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            {
                                tempValues.informationPictures.map((picture, index) => {
                                    return (<div key={index} className="col-md-2">
                                        <img
                                            className={`w-100 productImage`}
                                            src={picture}
                                        />
                                        {!picture.includes("product_information_picture") &&
                                            <button className={"btn btn-success w-100"} onClick={async () => {
                                                const imageUrl = await uploadInformationPictures(picture);
                                                const newTempValuesPicture = tempValues.informationPictures;
                                                newTempValuesPicture[index] = imageUrl;
                                                changeTempValues("informationPictures", newTempValuesPicture);
                                            }}>
                                                آپلود
                                            </button>}
                                        {picture.includes("product_information_picture") &&
                                            <button className={"btn btn-success w-100"} onClick={async () => {
                                                toastSuccess("لینک کپی شد!");
                                                navigator.clipboard.writeText(picture)
                                            }
                                            }>
                                                <FontAwesomeIcon icon={faCopy}/>
                                                {picture}
                                            </button>}
                                    </div>)
                                })
                            }
                            <div className="col-md-2">
                                <ImageInput aspect={4 / 5} onChange={(value) => {
                                    const newTempPictures = [...tempValues.informationPictures, value];
                                    changeTempValues("informationPictures", newTempPictures)
                                }}/>
                            </div>
                        </div>
                        <TextEditor label={"توضیحات متنی"} value={productForm.informationText} onChange={(value) => {
                            changeProduct("informationText", value)
                        }}/>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <label className="card-title mb-2 d-block">مشخصات فنی به شکل جدول</label>
                        <div className="table-responsive">
                            <table className={"table text-center"}>
                                <thead>
                                <tr>
                                    <th className={"w-25"}>ویژگی</th>
                                    <th className={'w-75'}>مقدار</th>
                                    <th/>
                                </tr>
                                </thead>
                                <tbody>
                                {productForm.informationTable.map((feature, index) => {
                                    return (<tr key={index}>
                                            <td>
                                                <TextInputWithoutContainer value={feature.attribute}
                                                                           onChange={(value) => {
                                                                               const newTable = [...productForm.informationTable];
                                                                               newTable[index].attribute = value;
                                                                               changeProduct("informationTable", newTable);
                                                                           }}/>
                                            </td>
                                            <td>
                                                <TextInputWithoutContainer value={feature.value} onChange={(value) => {
                                                    const newTable = [...productForm.informationTable];
                                                    newTable[index].value = value;
                                                    changeProduct("informationTable", newTable);
                                                }}/>
                                            </td>
                                            <td>
                                                <button className={"btn btn-danger"}>
                                                    <FontAwesomeIcon icon={faTrash} onClick={() => {
                                                        const newTable = productForm.informationTable.filter((f, i) => {
                                                            if (i != index) {
                                                                return f;
                                                            }
                                                        })
                                                        changeProduct("informationTable", newTable);
                                                    }}/>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })}

                                <tr>
                                    <td colSpan={3}>
                                        <button className={"btn btn-success w-100"} onClick={() => {
                                            const newTable = [...productForm.informationTable, {
                                                attribute: "",
                                                value: ""
                                            }]
                                            changeProduct("informationTable", newTable);
                                        }}>
                                            <FontAwesomeIcon icon={faPlus} className={"ms-2"}/>
                                            افزودن سطر
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12">
                <TreeSelect label={"دسته بندی"}
                            data={listToTree(allProductCategoryObject, productForm.productCategoryIds)}
                            onChange={(value) => {
                                changeProduct("productCategoryIds", value)
                            }}/>
            </div>

            <div className="col-md-6">
                <Select label={"نوع کالا"} options={allProductTypeObject} value={productForm.productTypeId}
                        onChange={(value) => {
                            changeProduct("productTypeId", value)
                        }}/>
            </div>
            <div className="col-md-6">
                <Select label={"نحوه فروش"} options={allSellingTypeObject} value={productForm.sellingTypeId}
                        onChange={(value) => {
                            changeProduct("sellingTypeId", value)
                        }}/>
            </div>

            <div className="col-md-6">
                <ColorForm singleProducts={productForm.singleProducts} onChange={(value) => {
                    changeProduct("singleProducts", value)
                }}/>
            </div>

            <div className="col-md-6">
                <SizeForm singleProducts={productForm.singleProducts} onChange={(value) => {
                    changeProduct("singleProducts", value)
                }}/>
            </div>

            {isSellable(productForm.sellingTypeId) && <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <label className="card-title mb-2 d-block">قیمت گذاری</label>
                        <div role="group" className="btn-group btn-group-lg ltr w-100 mb-4">
                            {
                                allCurrencyObject.map((currency, index) => {
                                    return (
                                        <button onClick={() => {
                                            changeProduct("currency", currency)
                                        }} key={index} type="button"
                                                className={`btn ${productForm.currency.id == currency.id ? 'btn-primary' : 'btn-outline-primary'}`}>
                                            <span>{currency.name}</span>
                                            <br/>
                                            <span>نرخ: {currency.rate.toLocaleString()}</span>
                                        </button>
                                    );
                                })
                            }
                        </div>

                        <div className="col-md-4">
                            <SelectWithoutContainer options={pricingMethodOptions} value={productForm.pricingMethod}
                                                    onChange={(value) => {
                                                        changeProduct("pricingMethod", value)
                                                    }}/>
                        </div>

                        <PricingForm product={productForm}
                                     onChange={(value) => {
                                         setProductForm(value);
                                         onChange(value);
                                     }}

                        />

                    </div>
                </div>
            </div>}
        </div>
    );
};

export default ProductForm;